<div #chart></div>
<div #legend ></div>
